module.exports = __webpack_public_path__ + "./images/sorting-arrow.svg";